var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#ccc;}.cls-4{fill:#939393;}.cls-5{fill:#ff7e74;}.cls-6{fill:#00d89a;}.cls-7{fill:#00a0df;}.cls-8{fill:#ffff9d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.93,156.52V576.41a22.54,22.54,0,0,1-22.56,22.51h-453a22.54,22.54,0,0,1-22.57-22.51V22.63A22.54,22.54,0,0,1,74.35.12H393.17a22.59,22.59,0,0,1,15.95,6.59l134.2,133.9A22.43,22.43,0,0,1,549.93,156.52Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 81") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_77",
    "data-name": "Layer 77"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M549.93,156.52V576.41a22.54,22.54,0,0,1-22.56,22.51h-453a22.54,22.54,0,0,1-22.57-22.51V22.63A22.54,22.54,0,0,1,74.35.12H393.17a22.59,22.59,0,0,1,15.95,6.59l134.2,133.9A22.43,22.43,0,0,1,549.93,156.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M552.57,147.2H424a23.17,23.17,0,0,1-23.2-23.14V-3.81L401-4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 121.8,
    y: 378.16,
    width: 353.99,
    height: 48.97,
    rx: 24.49,
    transform: "translate(3.05 -2.24) rotate(0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 121.04,
    y: 476.1,
    width: 353.99,
    height: 48.97,
    rx: 24.49,
    transform: "translate(3.79 -2.23) rotate(0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 122.55,
    y: 280.21,
    width: 352.95,
    height: 48.97,
    rx: 24.49,
    transform: "translate(2.31 -2.25) rotate(0.43)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.66,223.92V80.34a24.89,24.89,0,0,0-24.89-24.89h0a24.89,24.89,0,0,0-24.89,24.89V223.92a6.83,6.83,0,0,0,6.83,6.83h36.11A6.83,6.83,0,0,0,174.66,223.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.59,134.15H347.3a6.83,6.83,0,0,1,6.83,6.83v36.11a6.83,6.83,0,0,1-6.83,6.83H235.59A24.89,24.89,0,0,1,210.7,159v0A24.89,24.89,0,0,1,235.59,134.15Z",
    transform: "translate(441.45 -123.38) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M192.51,157.44h65.12a6.83,6.83,0,0,1,6.83,6.83v36.11a6.83,6.83,0,0,1-6.83,6.83H192.51a24.89,24.89,0,0,1-24.89-24.89v0a24.89,24.89,0,0,1,24.89-24.89Z",
    transform: "translate(398.37 -33.72) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M373.67,223.92V139.18a24.89,24.89,0,0,0-24.88-24.89h0a24.89,24.89,0,0,0-24.89,24.89v84.74a6.83,6.83,0,0,0,6.83,6.83h36.11A6.83,6.83,0,0,0,373.67,223.92Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.702efe8188dfc7f29964691c27f5cdf7.svg";
export { ForwardRef as ReactComponent };